import type { ComponentProps } from "react"
import { SelectScrollDownButton as SelectScrollDownButtonBase } from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectScrollDownButtonProps = ComponentProps<
  typeof SelectScrollDownButtonBase
>

function SelectScrollDownButton(props: SelectScrollDownButtonProps) {
  const { className, ...selectScrollDownButtonBaseProps } = props
  return (
    <SelectScrollDownButtonBase
      className={cn("ui-select-scroll-down-button", className)}
      {...selectScrollDownButtonBaseProps}
    />
  )
}

export default SelectScrollDownButton
